import { render, staticRenderFns } from "./Retirement.vue?vue&type=template&id=3b0ba669&scoped=true"
import script from "./Retirement.vue?vue&type=script&lang=js"
export * from "./Retirement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0ba669",
  null
  
)

export default component.exports